const LEADS_METADATA_KEYS = [
  'leadsListId',
  'leadsListName',
  'leadsListIds',
  'leadsListNames'
];

function createNodeId(index) {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `node_${crypto.randomUUID()}`;
  }

  return `node_${Date.now()}_${index}`;
}

function cloneNode(node, nextIndex) {
  if (!node || typeof node !== 'object') {
    return node;
  }

  const clonedNode = {
    ...node,
    data: node.data ? { ...node.data } : {}
  };

  clonedNode.id = node.type === 'start' ? 'start' : createNodeId(nextIndex());

  if (Object.prototype.hasOwnProperty.call(node, 'child')) {
    clonedNode.child = cloneNode(node.child, nextIndex);
  }
  if (Object.prototype.hasOwnProperty.call(node, 'yesChild')) {
    clonedNode.yesChild = cloneNode(node.yesChild, nextIndex);
  }
  if (Object.prototype.hasOwnProperty.call(node, 'noChild')) {
    clonedNode.noChild = cloneNode(node.noChild, nextIndex);
  }

  return clonedNode;
}

export function cloneCampaignWorkflow(workflow) {
  if (!workflow || !Array.isArray(workflow.nodes)) {
    return null;
  }

  const workflowCopy = JSON.parse(JSON.stringify(workflow));
  let index = 0;
  const nextIndex = () => {
    index += 1;
    return index;
  };
  const clonedWorkflow = {
    ...workflowCopy,
    nodes: workflowCopy.nodes.map(node => cloneNode(node, nextIndex))
  };

  LEADS_METADATA_KEYS.forEach(key => {
    delete clonedWorkflow[key];
  });

  return clonedWorkflow;
}

export function countWorkflowSteps(workflow) {
  const visit = node => {
    if (!node || typeof node !== 'object') {
      return 0;
    }

    const current = node.type === 'start' || node.type === 'end' ? 0 : 1;
    return current + visit(node.child) + visit(node.yesChild) + visit(node.noChild);
  };

  if (!workflow || !Array.isArray(workflow.nodes)) {
    return 0;
  }

  return workflow.nodes.reduce((total, node) => total + visit(node), 0);
}
